goog.provide("shadow.js.shim.module$$mui$material$Skeleton$default");
shadow.js.shim.module$$mui$material$Skeleton$default = shadow.js.shim.module$$mui$material$Skeleton.default;
